// src/pages/AviationPilotATCPathways.jsx
// Renamed from AviationPilotATCPathways.jsx per user request
// Also fixed syntax error at the end of the original file
import React from 'react';
// Assuming Header and Footer are in ../components/
// Commenting out to prevent build errors if paths are wrong
// import Header from '../components/Header'; 
// import Footer from '../components/Footer';

// Renamed component to match filename
const AviationPilotATCPathways = () => { 
  return (
    // Replaced inline styles with Tailwind classes for consistency
    <div className="font-sans bg-gray-50 text-gray-800 leading-relaxed relative min-h-screen">
      
      {/* Top Right Navigation */}
      {/* Using Tailwind for styling */}
   
      {/* Header */}
      <header className="text-center py-10 px-5 bg-blue-800 text-white">
        <h1 className="text-2xl md:text-3xl font-bold">✈️ Pilot & ATC Bundle | Aulice</h1>
        <p className="mt-2">Your Path to Aviation Radiotelephony Mastery</p>
      </header>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto py-10 px-5">
        <div id="pathway" className="bg-white p-6 md:p-8 rounded-xl shadow-lg">
          <h2 className="text-2xl font-bold text-blue-800 mb-6 text-center">🧭 Mastery Pathway: Pilot & ATC English</h2>

          {/* Phase 1 */}
          <div className="mb-6 p-5 bg-blue-50 border-l-4 border-blue-800 rounded">
            <h3 className="text-xl font-bold text-blue-800 mb-3">Phase 1: Foundations of Radiotelephony (Units 1–30)</h3>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse mb-3 min-w-[400px]">
                <thead>
                  <tr className="border-b">
                    <th className="text-left py-2 px-3 bg-blue-800 text-white font-semibold">Unit</th>
                    <th className="text-left py-2 px-3 bg-blue-800 text-white font-semibold">Title</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">1</td><td className="py-2 px-3">Aviation English</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">2</td><td className="py-2 px-3">The Art of the Readback</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">3</td><td className="py-2 px-3">ICAO Radiotelephony Verbs</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">4</td><td className="py-2 px-3">Understanding Clearance</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">5</td><td className="py-2 px-3">"Go Ahead" and "Standby"</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">6</td><td className="py-2 px-3">Present Tense for Procedures</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">7</td><td className="py-2 px-3">Mastering Numbers & Altitudes</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">8</td><td className="py-2 px-3">Pronouncing Punctuation</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">9</td><td className="py-2 px-3">Articles in Transmission</td></tr>
                  <tr className="hover:bg-gray-50"><td className="py-2 px-3">10</td><td className="py-2 px-3">Call Sign Structure</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Phase 2 */}
          <div className="mb-6 p-5 bg-blue-50 border-l-4 border-blue-800 rounded">
            <h3 className="text-xl font-bold text-blue-800 mb-3">Phase 2: Departure & Climb (Units 31–60)</h3>
            <p className="font-medium"><strong>Focus:</strong> Takeoff, SID, climb, en route, emergencies.</p>
          </div>

          {/* Phase 3 */}
          <div className="mb-6 p-5 bg-blue-50 border-l-4 border-blue-800 rounded">
            <h3 className="text-xl font-bold text-blue-800 mb-3">Phase 3: En Route & Navigation (Units 61–90)</h3>
            <p className="font-medium"><strong>Focus:</strong> Position reporting, weather, deviations.</p>
          </div>

          {/* Phase 4 */}
          <div className="mb-6 p-5 bg-blue-50 border-l-4 border-blue-800 rounded">
            <h3 className="text-xl font-bold text-blue-800 mb-3">Phase 4: Approach & Landing (Units 91–120)</h3>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse mb-3 min-w-[400px]">
                <thead>
                  <tr className="border-b">
                    <th className="text-left py-2 px-3 bg-blue-800 text-white font-semibold">Unit</th>
                    <th className="text-left py-2 px-3 bg-blue-800 text-white font-semibold">Title</th>
                  </tr>
                </thead>
                <tbody className="text-sm">
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">95</td><td className="py-2 px-3">Decoding METAR/TAF Reports</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">96</td><td className="py-2 px-3">TAF Decoding & Communication</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">97</td><td className="py-2 px-3">Unstable Approaches & Go-Arounds</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">98</td><td className="py-2 px-3">Missed Approach Procedures</td></tr>
                  <tr className="border-b hover:bg-gray-50"><td className="py-2 px-3">99</td><td className="py-2 px-3">Final Approach Checklists</td></tr>
                  <tr className="hover:bg-gray-50"><td className="py-2 px-3">100</td><td className="py-2 px-3">Runway Vacated & Taxi</td></tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Phase 5 */}
          <div className="mb-6 p-5 bg-blue-50 border-l-4 border-blue-800 rounded">
            <h3 className="text-xl font-bold text-blue-800 mb-3">Phase 5: Non-Standard & Advanced (Units 121–150)</h3>
            <p className="font-medium"><strong>Focus:</strong> Engine failure, medical emergency, Mayday, holding, CRM.</p>
          </div>

          {/* Phase 6 */}
          <div className="mb-6 p-5 bg-blue-50 border-l-4 border-blue-800 rounded">
            <h3 className="text-xl font-bold text-blue-800 mb-3">Phase 6: Professional Development (Units 151–180)</h3>
            <p className="font-medium"><strong>Focus:</strong> Human factors, ICAO LPR prep, simulator scenarios, final exam.</p>
          </div>
        </div>
      </div>

  
    </div>
  );
};

export default AviationPilotATCPathways;
